import { ref } from "#imports";
export var NotificationTypes = /* @__PURE__ */ ((NotificationTypes2) => {
  NotificationTypes2["Success"] = "success";
  NotificationTypes2["Error"] = "error";
  return NotificationTypes2;
})(NotificationTypes || {});
function addId(notification) {
  if (!notification.id) {
    notification.id = (/* @__PURE__ */ new Date()).toISOString();
  }
}
export const notifications = ref([]);
function pushNotification(notification) {
  if (notification.message) {
    addId(notification);
    notifications.value.unshift(notification);
    if (notification.closeAfter > 0) {
      setTimeout(() => deleteNotification(notification.id), notification.closeAfter);
    }
  }
}
export function deleteNotification(id) {
  const index = notifications.value.findIndex((el) => el.id === id);
  if (index > -1) {
    notifications.value.splice(index, 1);
  }
}
export function addSuccessNotification(message, { tc = false, closeAfter = 3e3 } = {}) {
  pushNotification({
    type: "success" /* Success */,
    tc,
    message,
    closeAfter
  });
}
export function addErrorNotification(message, { tc = false, closeAfter = 5e3 } = {}) {
  pushNotification({
    type: "error" /* Error */,
    tc,
    message,
    closeAfter
  });
}
